<template>
  <div class="stage-level-detail pa-3">
    <div class="caption text--secondary">
      {{ selectedObservatory.address }}
    </div>
    <div class="caption text--secondary">
      {{ selectedObservatory.lat }}, {{ selectedObservatory.lng }}
    </div>
    <div class="caption my-4" v-if="isMissing">
      この観測所は欠測しています。
    </div>
    <template v-else>
      <SnowChart
        :height="230"
        :selected-observatory="selectedObservatory"
        :currentDate="currentDate"
      />
      <v-simple-table v-if="tableData" dense class="mt-3">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">日時</th>
              <th class="text-left">気温</th>
              <th class="text-left">時間降雪</th>
              <th class="text-center">積雪深</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(ts, index) in tableData" :key="index">
              <td>{{ ts.date }}</td>
              <td class="text-right">
                {{
                  ts.temperature !== null && ts.temperature !== undefined
                    ? ts.temperature
                    : "・"
                }}
              </td>
              <td class="text-right">
                {{ ts.snow !== null && ts.snow !== undefined ? ts.snow : "・" }}
              </td>
              <td class="text-right">
                {{
                  ts.snowTotal !== null && ts.snowTotal !== undefined
                    ? ts.snowTotal
                    : "・"
                }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import moment from "moment/moment";
import SnowChart from "@/components/base-map/details/SnowChart.vue";

export default {
  name: "SnowDetail",
  components: { SnowChart },
  data() {
    return {
      tableData: null
    };
  },
  computed: {
    currentDate() {
      const baseDate = this.$store.getters.baseDate.clone();
      return baseDate
        .subtract(baseDate.minute() % 10, "minutes")
        .format("YYYY/MM/DD HH:mm");
    },
    selectedObservatory() {
      return this.$store.getters.selectedObservatory;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    },
    timeSeries() {
      return this.$store.getters.selectedObservatory.timeSeries;
    },
    isMissing() {
      return this.selectedObservatory.status === null;
    }
  },
  watch: {
    selectedObservatory() {
      this.setTableData();
    }
  },
  created() {
    this.setTableData();
  },
  methods: {
    setTableData() {
      const tableData = [];
      this.timeSeries.forEach(ts => {
        const row = {
          date: this.getDate(ts.date),
          temperature: ts.atmospheric_temperature,
          snow: ts.snow,
          snowTotal: ts.snow_total
        };
        tableData.push(row);
      });
      this.tableData = tableData;
    },
    getDate(date) {
      return moment
        .utc(date, "YYYY/MM/DD HH:mm")
        .local()
        .format("MM/DD HH:mm");
    }
  }
};
</script>

<style lang="scss" scoped>
.stage-level-detail {
  thead {
    background-color: #addff3;
  }
  tbody td {
    background: #eee;
  }
  tbody tr:nth-child(odd) td {
    background: #fff;
  }
  .std-color {
    width: 16px;
    height: 12px;
    border-bottom: white 3px solid;
  }
  .predict {
    color: blue;
  }
}
</style>
